import config from 'config';

const LOAD = 'horse-racing/meetings/LOAD';
const LOAD_SUCCESS = 'horse-racing/meetings/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/meetings/LOAD_FAIL';

const initialState = {
  byDate: {}
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        byDate: {
          ...state.byDate,
          [action.date]: {
            ...state.byDate[action.date],
            loading: true
          }
        }
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        byDate: {
          ...state.byDate,
          [action.date]: {
            meetings: action.result,
            loading: false,
            loaded: true
          }
        }
      };
    case LOAD_FAIL:
      return {
        ...state,
        byDate: {
          ...state.byDate,
          [action.date]: {
            ...state.byDate[action.date],
            loading: false,
            loaded: false,
            error: action.error
          }
        }
      };
    default:
      return state;
  }
}

export function isLoading(globalState, date) {
  return globalState.horseRacing.meetings
      && globalState.horseRacing.meetings.byDate
      && globalState.horseRacing.meetings.byDate[date]
      && globalState.horseRacing.meetings.byDate[date].loading;
}

export function load(date) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(`${config.api.horseRacing.loadMeetings}/${date}`),
    date: date
  };
}

export function get(state) {
  return state.horseRacing.meetings.byDate;
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/meetings.js